import React from 'react'
import RehypeReact from 'rehype-react'

import POST_TYPES from 'lib/gatsby/types'

import ColorText from 'components/ColorText'
import Video from 'components/blog/Video'
import {
  ContentGIFVideo,
  BlogTestimonial,
  StyledH2,
  StyledH1,
  StyledH3,
  StyledH4,
  StyledH5,
} from './components'

const getASTRenderer = (type, components) => {
  switch (type) {
    case POST_TYPES.blog:
      return new RehypeReact({
        createElement: React.createElement,
        components: {
          'color-text': ColorText,
          video: Video,
          testimonial: BlogTestimonial,
          gifvideo: ContentGIFVideo,
          ...components,
        },
      }).Compiler
    case POST_TYPES.help:
      return new RehypeReact({
        createElement: React.createElement,
        components: {
          gifvideo: ContentGIFVideo,
          ...components,
        },
      }).Compiler
  }
}

export const getBlogASTRenderer = (htmlAst) => {
  return getASTRenderer(POST_TYPES.blog, {
    h1: StyledH1,
    h2: StyledH2,
    h3: StyledH3,
    h4: StyledH4,
    h5: StyledH5,
  })(htmlAst)
}

export const getHelpASTRenderer = (htmlAst) => {
  return getASTRenderer(POST_TYPES.help, {
    h1: StyledH1,
    h2: StyledH2,
    h3: StyledH3,
    h4: StyledH4,
    h5: StyledH5,
  })(htmlAst)
}
